export default __webpack_public_path__ + "99b47c1e5468b1244eb19dae72d20fa1.png";